export default __webpack_public_path__ + "static/media/buttons2.2bc90602.jpg";